import config from 'config';
import { isMobile } from 'react-device-detect';
import {bannerAd, singleBottomMPUProps, topMPUProps, rosBottomMpuProps} from "../modules/Common/components/GptProperties";

const componentLayoutDefinition = (name, dOrd = 1, hOrd = false, dCol = 'right', props) => ({
  component: name,
  desktopOrder: dOrd,
  handheldOrder: hOrd,
  desktopColumn: dCol,
  props
});

export const articleSensitivityLayout = (layout, notSensitive, sensitive) => {
  switch(layout) {
    default:
    case 'nonSensitive':
      return notSensitive;
    case 'sensitive':
      return sensitive;
  }
}

const plainTitleProps = {
  plainTitle: true
};

export const genericLayoutFactory = (sportName, advertView = sportName) => {
  const advertProps = {
      ocSlot: [sportName || "homepage", "mpu"],
      additionalProperties: {
          view: advertView
      }
  };

  const leaderboardAd = {
    view: advertView
  };

  const rosTopMpu    = componentLayoutDefinition('GooglePublisherTag', 2, false, 'right', topMPUProps);
  const advertOffers = componentLayoutDefinition('AdvertWrapper', 8, false, 'right', advertProps);
  const rosBottomMpu = componentLayoutDefinition('GooglePublisherTag', 9, false, 'right', rosBottomMpuProps);

  const RHSComponents = [
    componentLayoutDefinition("MostReadAll",            1, 3,     "right"),
    componentLayoutDefinition('RacingTips',             4, false, 'right', plainTitleProps),
    componentLayoutDefinition('HorseRacingNextRaceOff', 5, false, 'right', plainTitleProps),
    componentLayoutDefinition('FootballTips',           7, false, 'right', plainTitleProps)
  ];

  return {
    withAdverts: (...components) => ({
      bannerAd: bannerAd,
      leaderboardAd,
      components: [rosTopMpu, ...components, ...RHSComponents, advertOffers, rosBottomMpu]
    }),
    withArticleAdverts: (...components) => ({
      leaderboardAd,
      components: [rosTopMpu, ...components, ...RHSComponents, advertOffers, rosBottomMpu]
    }),
    withoutAdverts: (...components) => ({
      components: [...components, ...RHSComponents]
    })
  };
}


export const genericSportLayout = (sportName, advertView = sportName) => {
  const factory = genericLayoutFactory(sportName, advertView);

  const gptAdvertProps = {
    ocDetails: {
      ocSlot: [sportName || "homepage", "leaderboard"]
    },
    performDetails: singleBottomMPUProps
  };

  const HomePageLayout = factory.withAdverts(
    componentLayoutDefinition('MoreNews',   1, 1, 'left'),
    componentLayoutDefinition('GptAdvert',  2, 2, 'left', gptAdvertProps)
  );

  const ArticleLayout = factory.withArticleAdverts(
    componentLayoutDefinition('Article', 1, 1, 'left')
  );

  const ArticleSensitiveLayout = factory.withoutAdverts(
    componentLayoutDefinition('Article', 1, 1, 'left')
  );

  return {
    [`/${sportName}`]: HomePageLayout,
    [`/${sportName}/news/:title/:articleId`]: layout => articleSensitivityLayout(layout, ArticleLayout, ArticleSensitiveLayout)
  };
}

export const sortByDeviceDisplayOrder = (a, b) => {
  if (isMobile) {
    return a.handheldOrder > b.handheldOrder;
  }

  return a.desktopOrder > b.desktopOrder;
}

export const getLastIndexWithDeviceOrder = (col, side) => {
  const selectHighestIndexForDevice = (device, side) => {
    return (highestIdx, component, idx) => {
      const isDisplayedInCol = !component[`${device}Column`] || component[`${device}Column`] == side;
      if (component[`${device}Order`] !== false && isDisplayedInCol) {
        return idx;
      }
      return highestIdx
    }
  }

  const lastInstanceIndexes = {};
  lastInstanceIndexes.desktop = col.reduce(selectHighestIndexForDevice("desktop", side), 0);
  lastInstanceIndexes.handheld = col.reduce(selectHighestIndexForDevice("handheld", side), 0);

  return lastInstanceIndexes;
}



// WEBPACK FOOTER //
// ./utils/layoutUtils.js